import React from 'react';
import { Link } from 'react-router-dom';
import { useQuestionnaire } from '../contexts/QuestionnaireContext';

export default function Results() {
  const { state } = useQuestionnaire();

  // If no results, redirect to questionnaire
  if (!state.isComplete) {
    return (
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">No Results Yet</h1>
        <p className="text-gray-600 mb-8">
          Please complete the questionnaire to see your results.
        </p>
        <Link to="/questionnaire" className="btn-primary">
          Start Questionnaire
        </Link>
      </div>
    );
  }

  // Results are displayed in the Questionnaire component
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
      <p className="text-gray-600 mb-8">
        Redirecting to your results...
      </p>
      <Link to="/questionnaire" className="btn-primary">
        View Results
      </Link>
    </div>
  );
}
